export default {fields:{modified_at:{}},spreads:{FolderSummary:{}},typenameResolver:'FolderTypenameResolver'}